import { TodayPlan, PlanTaskOwner } from '../types/today';

// Sample owners
const owners: Record<string, PlanTaskOwner> = {
  john: {
    id: 'user-1',
    name: 'John Doe',
    email: 'john.doe@example.com',
  },
  sarah: {
    id: 'user-2',
    name: 'Sarah Chen',
    email: 'sarah.chen@example.com',
  },
  mike: {
    id: 'user-3',
    name: 'Mike Johnson',
    email: 'mike.johnson@example.com',
  },
  amy: {
    id: 'user-4',
    name: 'Amy Williams',
    email: 'amy.williams@example.com',
  },
  alex: {
    id: 'user-5',
    name: 'Alex Rodriguez',
    email: 'alex.rodriguez@example.com',
  },
};

/**
 * Sample "Today" plan data matching the Todoist-style design
 */
export const sampleTodayPlan: TodayPlan = {
  date: new Date().toISOString().split('T')[0],
  sections: [
    {
      id: 'my-projects',
      title: 'My Projects',
      tasks: [
        {
          id: 'task-1',
          title: 'Do 30 minutes of yoga',
          emoji: '🧘‍♂️',
          startTime: '07:30',
          expectedDurationMinutes: 30,
          isRecurring: true,
          hasReminder: true,
          sectionId: 'my-projects',
          owner: owners.john,
          isCompleted: false,
        },
        {
          id: 'task-2',
          title: 'Dentist appointment',
          startTime: '10:00',
          expectedDurationMinutes: 60,
          hasReminder: true,
          sectionId: 'my-projects',
          owner: owners.john,
          isCompleted: false,
        },
        {
          id: 'task-3',
          title: 'Buy bread',
          emoji: '🍞',
          expectedDurationMinutes: 15,
          sectionId: 'my-projects',
          owner: owners.john,
          isCompleted: false,
        },
      ],
    },
    {
      id: 'team',
      title: 'Team',
      tasks: [
        {
          id: 'task-4',
          title: 'Plan user research sessions',
          startTime: '14:00',
          expectedDurationMinutes: 90,
          sectionId: 'team',
          owner: owners.sarah,
          isCompleted: false,
        },
        {
          id: 'task-5',
          title: "Provide feedback on Amy's design",
          expectedDurationMinutes: 20,
          sectionId: 'team',
          owner: owners.amy,
          isCompleted: false,
        },
        {
          id: 'task-6',
          title: 'All-hands meeting',
          startTime: '16:00',
          expectedDurationMinutes: 60,
          isRecurring: true,
          sectionId: 'team',
          owner: owners.alex,
          isCompleted: false,
        },
      ],
    },
  ],
};
